export interface ProductDetails {
  id: string;
  examName: string;
  examDescription: string;
  numberOfQuestions: number;
  highYieldQuestions?: number;
  questionTypes: string[];
  keyFeatures: string[];
  topicsCovered?: string[];
  examFormat: string;
  examDuration?: string;
  examDate?: string;
  whoIsThisFor?: string[];
  fullDescription?: string;
}

export const productDetails: Record<string, ProductDetails> = {
  frcophth1: {
    id: "frcophth1",
    examName: "FRCOphth Part 1",
    examDescription: "Pass FRCOphth Part 1 with Confidence. The Most Comprehensive FRCOphth Part 1 Question Bank Available.",
    numberOfQuestions: 3750,
    highYieldQuestions: 500,
    questionTypes: ["Multiple Choice Questions (MCQ)", "High-Yield Exam Questions"],
    topicsCovered: [
      "Anatomy",
      "Biochemistry and Biostatistics",
      "Optics",
      "Pathology",
      "Pharmacology",
      "Clinical Genetics",
      "Microbiology & Immunology",
      "Statistics & Evidence-Based Medicine",
      "Investigations & Imaging",
      "Instruments, Lasers, & Optics",
      "Physiology",

    ],
    keyFeatures: [
      "3,750+ carefully written multiple-choice questions covering the full FRCOphth Part 1 curriculum",
      "500+ high-yield exam questions focused on commonly examined topics and repeated exam themes",
      "Complete syllabus coverage across all basic sciences",
      "Clear, detailed explanations for every question with exam-relevant teaching points",
      "Built-in analytics to track progress, identify weak areas, and focus revision",
      "Fully mobile-friendly - revise anywhere, anytime on phone, tablet, or desktop",
      "Exam-style MCQs with realistic difficulty and time-pressured practice",
      "Designed specifically for the RCOphth Part 1 exam, focusing on core basic sciences, frequently tested concepts, common exam traps, and high-yield facts"
    ],
    examFormat: "Computer-based multiple choice examination",
    examDuration: "3 hours",
    examDate: "Held multiple times per year",
    whoIsThisFor: [
      "Ophthalmology trainees preparing for FRCOphth Part 1",
      "Doctors early in ophthalmic training",
      "Candidates who want structured, exam-accurate MCQ practice",
      "Anyone serious about passing on the first attempt"
    ],
    fullDescription: "The FRCOphth Part 1 syllabus is vast, detailed, and heavily knowledge-based. Many candidates fail not due to lack of effort — but because they revise inefficiently, without exposure to realistic exam-style questions. OphthalmologyQ fixes that. Study What Actually Appears in the Exam. The OphthalmologyQ Part 1 FRCOphth Question Bank is built specifically for the RCOphth Part 1 exam, focusing on core basic sciences, frequently tested concepts, common exam traps, and high-yield facts that repeatedly appear in questions. This is not generic ophthalmology revision — it is exam-targeted practice."
  },
  frcophth2: {
    id: "frcophth2",
    examName: "FRCOphth Part 2 (Written)",
    examDescription: "The FRCOphth Part 2 Written examination focuses on advanced ophthalmology knowledge and clinical decision-making. This exam tests your ability to apply clinical knowledge to complex scenarios, demonstrating readiness for higher specialty training and independent practice in ophthalmology.",
    numberOfQuestions: 2500,
    questionTypes: ["Multiple Choice Questions (MCQ)", "Single Best Answer (SBA)", "Extended Matching Questions (EMQ)"],
    keyFeatures: [
      "Advanced clinical scenarios and case-based questions",
      "Coverage of all subspecialty areas in ophthalmology",
      "Detailed explanations with evidence-based answers",
      "Performance analytics by topic and difficulty level"
    ],
    examFormat: "Computer-based written examination",
    examDuration: "3 hours",
    examDate: "Held multiple times per year"
  },
  msra: {
    id: "msra",
    examName: "MSRA (Multi-Specialty Recruitment Assessment)",
    examDescription: "The MSRA is a computer-based assessment used for recruitment into specialty training programs, including ophthalmology. It evaluates clinical knowledge, professional judgment, and decision-making skills across various medical specialties.",
    numberOfQuestions: 1500,
    questionTypes: ["Multiple Choice Questions (MCQ)", "Situational Judgment Test (SJT)"],
    keyFeatures: [
      "Clinical knowledge questions covering multiple specialties",
      "Situational Judgment Test scenarios relevant to ophthalmology training",
      "Questions aligned with MSRA format and difficulty",
      "Timed practice sessions to build exam stamina",
      "Performance tracking with percentile rankings"
    ],
    examFormat: "Computer-based assessment",
    examDuration: "2 hours 30 minutes",
    examDate: "Held multiple times per year for specialty recruitment"
  },
  interview_pack_st1: {
    id: "interview_pack_st1",
    examName: "Ophthalmology ST1 Interview",
    examDescription: "The ST1 (Specialty Training Year 1) interview for Ophthalmology is a structured assessment that evaluates your clinical knowledge, communication skills, professionalism, and suitability for specialty training. This pack provides comprehensive preparation materials including scenarios, actor briefs, candidate briefs, and mark schemes.",
    numberOfQuestions: 30,
    questionTypes: ["Role Play Scenarios", "Clinical Scenarios", "Communication Stations"],
    keyFeatures: [
      "30 comprehensive interview scenarios",
      "Actor briefs for role-play practice",
      "Candidate briefs with key talking points",
      "Detailed mark schemes showing what examiners look for",
      "Tips and strategies for each station type",
      "Common pitfalls and how to avoid them"
    ],
    examFormat: "Multi-station interview (typically 4-6 stations)",
    examDuration: "Approximately 1-2 hours",
    examDate: "Typically held in early spring for August start dates"
  }
};

